import graphql__a3b381d255a8a101f99d from "./__generated__/FeaturedContentCarousel_featuredContent.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import chunk from "lodash/chunk";

import FeaturedContentCarouselSlide from "./FeaturedContentCarouselSlide";
import resizeWindowOnContentImageLoad from "../Utils/resizeWindowOnContentImageLoad";
import SlideshowCarousel from "../Carousel/SlideshowCarousel";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";

const FeaturedContentCarousel = props => {
  const { isMobile } = useResponsiveFlag();
  const { featuredContentBlocks, autoplay, slidesInterval } = props.featuredContent;

  // Only display 1 element per row for mobile
  const blocksPerRow = isMobile ? 1 : props.featuredContent.blocksPerRow;

  if (featuredContentBlocks.length === 0) return null;

  return (
    <div
      className="featured-content featured-content-carousel"
      ref={resizeWindowOnContentImageLoad}
    >
      <SlideshowCarousel autoplay={autoplay} slidesInterval={slidesInterval}>
        {chunk(featuredContentBlocks, blocksPerRow).map((blocks, index) => (
          <FeaturedContentCarouselSlide key={index} blocks={blocks} />
        ))}
      </SlideshowCarousel>
    </div>
  );
};

export default createFragmentContainer(FeaturedContentCarousel, {
  featuredContent: graphql__a3b381d255a8a101f99d
});
